<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Edit Profile</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-3">
            <fg-input type="text"
                      label="Company"
                      placeholder="Company"
                      v-model="user.company">
            </fg-input>
          </div>
          <div class="col-md-2" v-if="role === 'agent'">
            <fg-input type="number"
                      label="Commission %"
                      placeholder="Commission %"
                      v-model="user.commission">
            </fg-input>
          </div>
          <div class="col-md-3">

            <fg-input type="text"
                      label="Username"
                      :disabled="true"
                      placeholder="Username"
                      v-model="user.login">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="password"
                      label="Password"
                      placeholder="Change password"
                      v-model="user.password">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="user.first_name">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="user.last_name">
            </fg-input>
          </div>
          <!--
          <div class="col-md-4">
            <fg-input type="date"
                      label="Birthday"
                      placeholder="Birthday"
                      v-model="user.birthday">
            </fg-input>
          </div>
          -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
                      label="Address"
                      placeholder="Home Address"
                      v-model="user.address">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="City"
                      placeholder="City"
                      v-model="user.locality">
            </fg-input>
          </div>

          <div class="col-md-6">
            <fg-input type="number"
                      label="Postal Code"
                      placeholder="ZIP Code"
                      v-model="user.postal_code">
            </fg-input>
          </div>
        </div>

                <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Phone"
                      placeholder="Phone"
                      v-model="user.phone">
            </fg-input>
          </div>

          <div class="col-md-6">
            <fg-input type="text"
                      label="Email"
                      placeholder="Email"
                      v-model="user.email">
            </fg-input>
          </div>
        </div>

        <div class="row">
        <div class="col-md-2">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateProfile">
            Update Profile
          </button>
        </div>
        <div class="col-md-10" >
          <button type="submit" style="float: right;" class="btn btn-danger btn-fill" @click.prevent="deleteProfile">
            DELETE
          </button>
        </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>

  </div>
</template>
<script>
  export default {
    data () {
      return {
        user : {},
        role : localStorage.role
      }
    },
    mounted() {
      this.getUser()
    },
    methods: {
      getUser() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/user/user',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: {id: this.$route.query.id.toString()},
        }).then(response => (
          this.user = response.data
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      updateProfile () {
        this.$http({
          method: 'put',
          url: this.$apiUrl + '/user/user',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: this.user,
        }).then(response => (
          this.$notify({
          message: 'profile updated',
          type: 'success',
          horizontalAlign: 'center',
          verticalAlign: 'top'
          })
                  //this.$router.push({path: '/search/users'})
        )).catch(err => {
          this.$notify({
            message: 'Impossible to update this profile',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })

      },
      deleteProfile () {
        this.$http({
          method: 'delete',
          url: this.$apiUrl + '/user/user',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: this.user,
        }).then(response => (
                this.$notify({
                  message: 'profile updated',
                  type: 'success',
                  horizontalAlign: 'center',
                  verticalAlign: 'top'
                }),
                        this.$router.push({path: '/search/users'})
        )).catch(err => {
          this.$notify({
            message: 'Impossible to update this profile',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })

      }
    }
  }

</script>
<style>

</style>
